import React from 'react'
import ReviewParameter from './ReviewParameter'

import {
  IProjectVersionSettingsReviewParameterOption,
} from '@SiteModules/ProjectVersionSettings/types'

const REVIEW_SOURCE_TRANSCRIPT_OPTION = 'review_source_transcript'
const REVIEW_TRANSLATIONS_OPTION = 'review_translations'

interface ReviewForDubbingParameterProps {
  readonly reviewModeOptionsForDubbing: string[]
  readonly hasNewTranscription: boolean
  setReviewModeOptionsForDubbing(newReviewModeOptionsForDubbing: string[]): void
}

const ReviewForDubbingParameter: React.FC<ReviewForDubbingParameterProps> = props => {
  const {
    reviewModeOptionsForDubbing,
    hasNewTranscription,
  } = props

  const availableOptions: IProjectVersionSettingsReviewParameterOption[] = [{
    name: REVIEW_SOURCE_TRANSCRIPT_OPTION,
    nameToShowInDropdown: 'Review source transcript',
    description: hasNewTranscription ? 'Correct the original transcript before translation.' : 'Transcript already generated.',
    disabled: !hasNewTranscription
  }, {
    name: REVIEW_TRANSLATIONS_OPTION,
    nameToShowInDropdown: 'Review translations',
    description: 'Edit translation text before generating audio dubbing.'
  }]

  const numberOfOptions = availableOptions.length
  let buttonText = ''

  if (reviewModeOptionsForDubbing.length === 0) {
    buttonText = '🚀 Automatic dubbing'
  } else if (reviewModeOptionsForDubbing.length === numberOfOptions) {
    buttonText = '🛡️ Full manual review'
  } else if (reviewModeOptionsForDubbing[0] === REVIEW_SOURCE_TRANSCRIPT_OPTION) {
    buttonText = '📝 Review source'
  } else if (reviewModeOptionsForDubbing[0] === REVIEW_TRANSLATIONS_OPTION) {
    buttonText = '🌍 Review translations'
  }

  return (
    <ReviewParameter
      reviewModeOptions={reviewModeOptionsForDubbing}
      availableOptions={availableOptions}
      setReviewModeOptions={props.setReviewModeOptionsForDubbing}
      buttonText={buttonText}
    />
  )
}

export default ReviewForDubbingParameter
